import React, { useEffect, useState } from 'react';

// Light / dark theme for the platform app. The preference lives in
// localStorage and is applied as `data-theme` on <html>; index.css overrides
// the :root tokens under [data-theme="light"]. The public marketing site
// stays dark (its art is dark) — only app routes honor the preference.
const KEY = 'nv.theme';

export function getTheme() {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

export function setTheme(theme) {
  try { localStorage.setItem(KEY, theme === 'light' ? 'light' : 'dark'); } catch { /* ignore */ }
  window.dispatchEvent(new Event('nv:theme'));
}

export function useTheme() {
  const [theme, set] = useState(getTheme);
  useEffect(() => {
    const on = () => set(getTheme());
    window.addEventListener('nv:theme', on);
    window.addEventListener('storage', on);
    return () => { window.removeEventListener('nv:theme', on); window.removeEventListener('storage', on); };
  }, []);
  return [theme, setTheme];
}

// Applies the preference to <html> while `active`; forces dark otherwise.
export function useApplyTheme(active) {
  const [theme] = useTheme();
  useEffect(() => {
    document.documentElement.dataset.theme = active ? theme : 'dark';
  }, [active, theme]);
}

export function ThemeToggle({ className = 'cs-btn cs-btn-outline cs-btn-sm' }) {
  const [theme, set] = useTheme();
  const light = theme === 'light';
  return (
    <button
      type="button"
      className={className}
      onClick={() => set(light ? 'dark' : 'light')}
      aria-pressed={light}
      title={light ? 'Switch to the dark theme' : 'Switch to the light theme'}
    >
      {light ? '☾ Dark' : '☀ Light'}
    </button>
  );
}
